import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";

import { HttpclientService } from "../../../../shared";
import { Subject } from "rxjs";
import { ApplicationAddRemoveRequest } from "./ApplicationAddRemoveRequest";

@Injectable()
export class DataService_AppSetup {
	constructor(private http: HttpClient, private httpclientService: HttpclientService) {}

	//INSERT CUSTOM METHODS HERE
	ApplicationTableSelectList() {
		var postResult$ = new Subject();
		var url = "SysAdmin/ApplicationTableSelectList?";
		//console.log(url);

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	ApplicationSchoolTableSelectList(ApplicationID) {
		var postResult$ = new Subject();
		var url = "SysAdmin/ApplicationSchoolTableSelectList?ApplicationID=" + ApplicationID;
		//console.log(url);

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	ApplicationItemTableSelectList(ApplicationID) {
		var postResult$ = new Subject();
		var url = "SysAdmin/ApplicationItemTableSelectList?ApplicationID=" + ApplicationID;
		//console.log(url);

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	ApplicationRemoveSchools(parms: ApplicationAddRemoveRequest) {
		var postResult$ = new Subject();
		var url = "SysAdmin/ApplicationRemoveSchools";
		//console.log(url);

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	ApplicationAddSchools(parms: ApplicationAddRemoveRequest) {
		var postResult$ = new Subject();
		var url = "SysAdmin/ApplicationAddSchools";
		//console.log(url);

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}
}
